export const LEGAL_UPDATE_VERSION = 'terms-privacy-2026-05-17';
export const TERMS_UPDATED_AT = '2026-05-17';
export const PRIVACY_UPDATED_AT = '2026-05-17';
export const LEGAL_UPDATE_SUMMARY = 'Uploaded media, moderation checks, access controls, retention, and deletion wording updated.';
